













































































































import { Component, Vue, Model, Watch } from 'vue-property-decorator';
// @ts-ignore
import { Editor, EditorContent, EditorMenuBar } from 'tiptap';
import {
    Blockquote,
    CodeBlock,
    HardBreak,
    Heading,
    HorizontalRule,
    OrderedList,
    BulletList,
    ListItem,
    TodoItem,
    TodoList,
    Bold,
    Code,
    Italic,
    Link,
    Strike,
    Underline,
    History,
    // @ts-ignore
} from 'tiptap-extensions';

@Component({
    components: {
        EditorContent,
        EditorMenuBar,
    },
})
export default class TextEditor extends Vue {
    @Model('update:value') readonly value!: string;
    pValue: string = '';
    focus: boolean = false;
    editor: Editor | null = null;

    onFocus(value: boolean) {
        this.focus = value;
    }

    updateValue(value: string) {
        this.pValue = value;
    }

    @Watch('value')
    onValue() {
        if (this.pValue) {
            return;
        }
        this.pValue = this.value;
        if (this.editor) {
            this.editor.setContent(this.value);
        }
    }
    @Watch('pValue')
    onPValue() {
        this.$emit('update:value', this.pValue);
    }

    beforeDestroy() {
        if (this.editor) {
            this.editor.destroy();
        }
    }

    mounted() {
        this.editor = new Editor({
            extensions: [
                new Blockquote(),
                new BulletList(),
                new CodeBlock(),
                new HardBreak(),
                new Heading({ levels: [1, 2, 3] }),
                new HorizontalRule(),
                new ListItem(),
                new OrderedList(),
                new TodoItem(),
                new TodoList(),
                new Link(),
                new Bold(),
                new Code(),
                new Italic(),
                new Strike(),
                new Underline(),
                new History(),
            ],
            onUpdate: (value: any) => {
                this.updateValue(value.getHTML());
            },
            onFocus: () => {
                this.onFocus(true);
            },
            onBlur: () => {
                this.onFocus(false);
            },
        });

        this.pValue = this.value;
        this.editor.setContent(this.value);
    }
}
